'use client';

import { Box, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslate } from '@jd/i18n';
import RichText, { RichTextContent } from '../../../../RichText';

type Props = {
  message: RichTextContent;
  onClose: () => void;
};

const ConfirmationMessage = ({ message, onClose }: Props) => {
  const common_t = useTranslate('common');

  return (
    <>
      <IconButton
        aria-label={common_t('close')}
        onClick={onClose}
        sx={{ position: 'absolute', top: 8, right: 8 }}
      >
        <CloseIcon />
      </IconButton>
      <Box
        role="status"
        aria-live="polite"
        sx={{
          maxWidth: { xs: '100%', sm: 520 },
          px: { xs: 3, md: 4 },
          textAlign: 'center',
          color: 'text.primary',
        }}
      >
        <RichText>{message}</RichText>
      </Box>
    </>
  );
};

export default ConfirmationMessage;
